import axios from "axios";
import { getEnhancedAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;
const validToken = localStorage.getItem("token");

export const getAllUsers = async () => {
  try {
    const users = await axios.get(`${backendUrl}/users`, {
      headers: getEnhancedAuthHeaders(),
    });
    return users.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getUserById = async (id) => {
  try {
    const user = await axios.get(`${backendUrl}/users/${id}`, {
      headers: getEnhancedAuthHeaders(),
    });
    console.log("user in user api:", user.data);

    return user.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getUserPublicData = async (id) => {
  try {
    const user = await axios.get(`${backendUrl}/users/${id}/public`, {
      headers: getEnhancedAuthHeaders(),
    });
    return user.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export const getUserByEmail = async (email) => {
  console.log("email in user api:", email);
  try {
    const user = await axios.get(`${backendUrl}/users/email`, {
      params: { email },
      headers: {
        Authorization: `Bearer ${validToken}`,
      },
    });
    return user.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const registerUser = async (user) => {
  try {
    const newUser = await axios.post("/users", user);
    return newUser.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const sendResetPasswordEmail = async (email, captchaToken) => {
  try {
    const response = await axios.post(`${backendUrl}/users/reset-password`, {
      email,
      captchaToken,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const resetPassword = async (token, password) => {
  try {
    const response = await axios.put(
      `${backendUrl}/users/reset-password/${token}`,
      { password },
      {
        headers: {
          Authorization: `Bearer ${validToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
